export enum PresentationDraftStatus {
	Generating = "Generating",
	Generated = "Generated",
	Failed = "Failed",
	Published = "Published",
	Discarded = "Discarded"
}

export enum GrammaticalGender {
	Feminine = "Feminine",
	Masculine = "Masculine"
}

export interface PresentationDimensionCoverage {
	dimension: string;
	location: string;
	clientBenefit: string;
}

export interface PresentationAssistantNotes {
	dimensions: PresentationDimensionCoverage[];
	pointsToVerify: string[];
	choices: string[];
}

export interface PresentationDraft {
	id: number;
	version: number;
	freelancerProfileId: number;
	parentDraftId?: number | null;
	status: PresentationDraftStatus;
	languageCode: string;
	gender: GrammaticalGender;
	extraInstruction?: string | null;
	content: string;
	hasManualEdits: boolean;
	assistantNotes?: PresentationAssistantNotes | null;
	failureReason?: string | null;
	model?: string | null;
	promptVersion?: string | null;
	isExemplary: boolean;
	createdAt: string;
	generationStartedAt: string;
	generatedAt?: string | null;
	publishedAt?: string | null;
	publishedById?: number | null;
}

export interface PresentationDraftSource {
	secondInterviewTranscript: string;
	firstInterviewTranscript?: string | null;
}

export interface StartPresentationDraftRequest {
	freelancerProfileId: number;
	secondInterviewTranscriptId?: number;
	secondInterviewTranscript?: string;
	firstInterviewTranscriptId?: number;
	firstInterviewTranscript?: string;
	gender: GrammaticalGender;
}

export enum InterviewKind {
	FirstInterview = "FirstInterview",
	SecondInterview = "SecondInterview"
}

export interface InterviewRecording {
	id: string;
	kind: InterviewKind;
	title: string;
	recordedAt: string;
	durationMinutes: number;
}

export enum InterviewMatchMethod {
	Manual = "Manual",
	Email = "Email",
	Name = "Name"
}

export interface InterviewTranscript {
	transcriptId: number;
	recordingId: string;
	kind: InterviewKind;
	matchMethod: InterviewMatchMethod;
	text: string;
}
